import React, { Component } from 'react';
import { connect } from 'react-redux';
import FormModal from 'components/shared/modal/FormModal';
import './ChangeOrderQuoteRequestModal.css';
import { getCurrentTask } from 'selectors/admin/work-orders/details/details';
import { getShowChangeOrderQuoteModal } from 'components/admin/work-orders/details/change-order-quotes/store/selectors';
import {
  setShowChangeOrderQuoteModal,
  requestChangeOrderQuote,
} from 'components/admin/work-orders/details/change-order-quotes/store/actions';
import ChangeOrderQuoteRequestForm from 'components/admin/work-orders/details/change-order-quotes/ChangeOrderQuoteRequestForm';

class ChangeOrderQuoteRequestModal extends Component {
  handleClose = () => {
    this.props.dispatch(setShowChangeOrderQuoteModal());
  };

  handleOnSubmit = (values) => {
    this.props.dispatch(
      requestChangeOrderQuote(this.props.changeOrderTask.id, values)
    );
  };

  render() {
    return (
      <div>
        <FormModal
          className="change-order-quote-request-modal"
          show={this.props.show}
          title="Change Order Pricing"
          onClose={this.handleClose}
        >
          <ChangeOrderQuoteRequestForm
            currentTask={this.props.currentTask}
            changeOrderTask={this.props.changeOrderTask}
            onSubmit={this.handleOnSubmit}
          />
        </FormModal>
      </div>
    );
  }
}

export default connect((state) => {
  return {
    currentTask: getCurrentTask(state),
    show: getShowChangeOrderQuoteModal(state),
  };
})(ChangeOrderQuoteRequestModal);



// WEBPACK FOOTER //
// ./src/components/admin/work-orders/details/change-order-quotes/ChangeOrderQuoteRequestModal.js